import React, { Component } from 'react'  
import PropTypes from 'prop-types';

class Button extends Component {
  constructor () {
    super();
    this.state = {
      backgroundImageVisible: false
    };
  }

  onMouseOverHandler() {
    this.setState({ backgroundImageVisible: true && this.props.backgroundImage });
  }

  onMouseLeaveHandler() {
    this.setState({ backgroundImageVisible: false && this.props.backgroundImage });
  }

  render(){
    return (
      <a href={this.props.link} target="_blank" className={`boxoffice highlights_slider_ticket_link ${this.props.link}`} >
        <span className="sk-button ${this.props.ticketLink}" 
              onMouseOver={() => this.onMouseOverHandler()}
              onMouseLeave={() => this.onMouseLeaveHandler()}
              style={{ backgroundImage: this.state.backgroundImageVisible ? `url(${this.props.backgroundImage})`: '',
                       color: this.state.backgroundImageVisible ? 'rgba(0, 0, 0, 0)' : '',
                       backgroundSize: 'cover'}}>
          {this.props.label}
        </span>
      </a>
    )
  }
}

export default Button;

Button.propTypes = {
  link: PropTypes.string,
  label: PropTypes.string,
  backgroundImage: PropTypes.string,
};